// #region Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik } from "formik";
import * as yup from "yup";

//FluentUI
import { Stack } from "office-ui-fabric-react/lib/Stack";
import {
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
  IColumn,
} from "office-ui-fabric-react/lib/DetailsList";
import { ShimmeredDetailsList } from "office-ui-fabric-react/lib/ShimmeredDetailsList";
import { SearchBox } from "office-ui-fabric-react/lib/SearchBox";
import { CommandBarButton, ICommandBarStyles } from "office-ui-fabric-react";
import { IDialogContentProps } from "office-ui-fabric-react/lib/Dialog";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";

import Panel from "~/components/layout/Panel";
import CustomDialog from "~/components/CustomDialogFluentUI";
import { Page, BreadcrumbItems } from "~/store/ducks/home/types";
import { InputText, InputCheckbox } from "~/components/Forms";

import { DeleteButton } from "~/components/Buttons";
import HeaderPage from "~/components/layout/HeaderPage";
import NoItems from "~/components/layout/NoItems";
import { PrimaryButton } from "~/components/Buttons";

//Estilos
import {
  Wrapper,
  ListContainer,
  DefaultButton,
  ContainerContent,
} from "./styles";

import { Creators as getMotivosAfastamentos } from "~/store/ducks/admin/motivoAfastamento";
import { Creators as getMotivoAfastamentoById } from "~/store/ducks/admin/motivoAfastamento";
import { Creators as addMotivoAfastamento } from "~/store/ducks/admin/motivoAfastamento";
import { Creators as editMotivoAfastamento } from "~/store/ducks/admin/motivoAfastamento";
import { Creators as delMotivoAfastamento } from "~/store/ducks/admin/motivoAfastamento";

import {
  DataTypes as DataTypesAfastamento,
  MotivoAfastamentoAddOrEditDTO,
  MotivosAfastamentosLoadDTO,
} from "~/store/ducks/admin/motivoAfastamento/types";

import { Creators as setCurrentPage } from "~/store/ducks/home";
import { RootState } from "~/store/ducks";
//#endregion

interface IMotivosAfastamentosState {
  columns: IColumn[];
  items: MotivosAfastamentosLoadDTO[];
  isPanelOpen: boolean;
  inicialValues: MotivoAfastamentoAddOrEditDTO;
  isFiltering: boolean;
  selectionDetails: string;
  selectionCount: number;
  isDialogCompetenceOpen: boolean;
  isDialogTypeOpen: boolean;
  isDialogExcludeOpen: boolean;
  search: string;
  newCompetenceText: string;
  newTypePDIText: string;
}

interface IPropsMotivosAfastamentos {
  motivosAfastamentos: DataTypesAfastamento;
  getMotivosAfastamentos: () => void;
  getMotivoAfastamentoById: (idMotivoAfastamento: number) => void;
  addMotivoAfastamento: (motivo: MotivoAfastamentoAddOrEditDTO) => void;
  editMotivoAfastamento: (motivo: MotivoAfastamentoAddOrEditDTO) => void;
  delMotivoAfastamento: (idMotivoAfastamento: number) => void;
  setCurrentPage: (page: Page) => void;
}

class MotivosAfastamentos extends Component<
  IPropsMotivosAfastamentos,
  IMotivosAfastamentosState
> {
  private formRef: any;
  private inputSearch: any;
  private _selection: Selection;

  constructor(props: IPropsMotivosAfastamentos) {
    super(props);
    //#region Colunas
    const columns: IColumn[] = [
      {
        key: "column1",
        name: "ID",
        ariaLabel: "ID do motivo de desligamento",
        fieldName: "idMotivoAfastamento",
        isRowHeader: true,
        minWidth: 75,
        maxWidth: 100,
        isResizable: true,
        isSortedDescending: false,
        onColumnClick: this._onColumnClick,
      },
      {
        key: "column2",
        name: "Descrição",
        fieldName: "descMotivoAfastamento",
        minWidth: 210,
        isRowHeader: true,
        isResizable: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: "Sorted A to Z",
        sortDescendingAriaLabel: "Sorted Z to A",
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
      },
    ];
    //#endregion

    this.state = {
      columns: columns,
      items: [],
      isPanelOpen: false,
      selectionDetails: "",
      inicialValues: initialMotivo,
      isFiltering: false,
      selectionCount: 0,
      isDialogExcludeOpen: false,
      search: "",
      isDialogCompetenceOpen: false,
      isDialogTypeOpen: false,
      newCompetenceText: "",
      newTypePDIText: "",
    };

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({
          selectionDetails: this._getSelectionDetails(),
        });
      },
    });

    this.formRef = React.createRef();
    this.inputSearch = React.createRef();
  }

  componentDidMount() {
    const page: Page = {
      key: "motivosAfastamentos",
      pages: itemsBreadCrumb,
    };
    this.props.setCurrentPage(page);
    this.props.getMotivosAfastamentos();
  }

  componentDidUpdate(prevProps: IPropsMotivosAfastamentos, _: any) {
    if (this.state.isPanelOpen) {
      if (
        prevProps.motivosAfastamentos.success !==
        this.props.motivosAfastamentos.success
      ) {
        if (this.props.motivosAfastamentos.success) {
          this.setState({ isPanelOpen: false });
        }
      }
    }

    if (
      this.props.motivosAfastamentos.itemSelected.success !==
      prevProps.motivosAfastamentos.itemSelected.success
    ) {
      if (this.props.motivosAfastamentos.itemSelected.success) {
        this.setState({
          inicialValues: this.props.motivosAfastamentos.itemSelected.item!,
        });
      }
    }

    // if (this.props.pdi.error !== prevProps.pdi.error) {
    //     if (this.props.pdi.error) {
    //         this.setState({ isPanelOpen: false, inicialValues: initialMotivo })
    //     }
    // }
  }

  // Submit do formulário Formik
  handleSubmit = () => {
    if (this.formRef.current) {
      this.formRef.current.handleSubmit();
    }
  };

  _onItemInvoked = (item: MotivosAfastamentosLoadDTO): void => {
    this.props.getMotivoAfastamentoById(item.idMotivoAfastamento);
    this.setState({
      isPanelOpen: true,
    });
  };

  _getSelectionDetails(): any {
    const selectionCount = this._selection.getSelectedCount();
    this.setState({ selectionCount });
    this._selection.getSelection();
  }

  openEdit = () => {
    const selected = this._selection.getSelection()[0] as MotivosAfastamentosLoadDTO;

    this.props.getMotivoAfastamentoById(selected.idMotivoAfastamento);
    this.setState({
      isPanelOpen: true,
    });
  };

  cancelPanel = () => {
    this._selection.setAllSelected(false);
    this.setState({ isPanelOpen: false });
  };

  exclude = () => {
    this.props.delMotivoAfastamento(
      (this._selection.getSelection()[0] as MotivosAfastamentosLoadDTO)
        .idMotivoAfastamento
    );
    this.setState({ isDialogExcludeOpen: false });
    this._selection.setAllSelected(false);
  };

  //#region  Funções do filtro

  handleSearch = (e: any) => {
    const data = this.props.motivosAfastamentos.data;
    const text = e?.target?.value;

    let items = text
      ? data.filter(
          (item) =>
            item
              .descMotivoAfastamento!.toLowerCase()
              .indexOf(text.toLowerCase()) > -1
        )
      : data;

    this.setState({ items, isFiltering: true, search: text });
  };

  //#endregion

  commandBarRender = () => {
    const { selectionCount } = this.state;
    if (selectionCount === 1) {
      return (
        <>
          <CommandBarButton
            styles={btnStyle}
            iconProps={{ iconName: "Edit" }}
            text="Editar"
            onClick={() => this.openEdit()}
          />
          <CommandBarButton
            styles={btnStyle}
            iconProps={{ iconName: "Delete" }}
            text="Excluir"
            onClick={() => this.setState({ isDialogExcludeOpen: true })}
          />
        </>
      );
    }
  };

  render() {
    const {
      isPanelOpen,
      isDialogExcludeOpen,
      inicialValues,
      isFiltering,
      items,
      columns,
      search,
    } = this.state;
    const {
      motivosAfastamentos,
      getMotivosAfastamentos,
      addMotivoAfastamento,
      editMotivoAfastamento,
    } = this.props;

    return (
      <>
        <Panel
          title={
            !inicialValues?.idMotivoAfastamento
              ? "Novo Motivo"
              : inicialValues?.descMotivoAfastamento
          }
          open={isPanelOpen}
          onClose={() => this.cancelPanel()}
          footer={
            <Stack horizontal tokens={{ childrenGap: 10 }}>
              <DefaultButton onClick={() => this.cancelPanel()}>
                Cancelar
              </DefaultButton>
              <PrimaryButton
                onClick={this.handleSubmit}
                isLoading={motivosAfastamentos.loadingAction}
                text="Salvar"
              />
            </Stack>
          }
        >
          {motivosAfastamentos.itemSelected.loading ? (
            <Spinner
              size={SpinnerSize.medium}
              styles={{ root: { height: "100%" } }}
            />
          ) : (
            <Formik
              innerRef={this.formRef}
              initialValues={inicialValues}
              validationSchema={validationMotivoSchema}
              validateOnChange={false}
              validateOnBlur={true}
              enableReinitialize
              onSubmit={(values: MotivoAfastamentoAddOrEditDTO) => {
                if (!values.idMotivoAfastamento) {
                  addMotivoAfastamento(values);
                } else {
                  editMotivoAfastamento(values);
                }
              }}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                errors,
                setFieldValue,
                setFieldError,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <InputText
                    value={values?.descMotivoAfastamento ?? ""}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldError("descMotivoAfastamento", "");
                    }}
                    id="descMotivoAfastamento"
                    error={errors.descMotivoAfastamento ? true : false}
                    name="descMotivoAfastamento"
                    type="text"
                    label="Descrição"
                    helperText={errors.descMotivoAfastamento}
                    className="mt-2"
                    autoFocus
                  />

                  <InputCheckbox
                    checked={values.flagMerito ?? false}
                    onChange={handleChange}
                    name="flagMerito"
                    color="primary"
                    label="Elegível ao mérito"
                  />
                </form>
              )}
            </Formik>
          )}
        </Panel>

        <Wrapper>
          <ContainerContent>
            <HeaderPage
              title="Motivos de Afastamentos"
              leftItems={
                <>
                  <CommandBarButton
                    styles={btnStyle}
                    iconProps={{ iconName: "Add" }}
                    disabled={motivosAfastamentos.loadingData}
                    text="Adicionar Motivo"
                    onClick={() =>
                      this.setState({
                        isPanelOpen: true,
                        inicialValues: initialMotivo,
                      })
                    }
                  />
                  {this.commandBarRender()}
                </>
              }
              rightItems={
                <>
                  <SearchBox
                    placeholder="Pesquisar"
                    value={search}
                    onChange={(e) => this.handleSearch(e)}
                    // onKeyUp={(e) => this.filter(e.key)}
                    componentRef={this.inputSearch}
                    styles={{
                      root: {
                        border: "none",
                        width: 200,
                        marginRight: 1,
                      },
                    }}
                  />
                  <CommandBarButton
                    styles={btnStyle}
                    iconProps={{ iconName: "Refresh" }}
                    text="Atualizar"
                    onClick={() => getMotivosAfastamentos()}
                  />
                </>
              }
            />
            {!motivosAfastamentos.loadingData &&
            motivosAfastamentos.data.length === 0 ? (
              <NoItems
                error={motivosAfastamentos.error}
                text="Não há motivos de afastamentos cadastradas"
                icon="Work"
              />
            ) : (
              <ListContainer>
                <ShimmeredDetailsList
                  items={isFiltering ? items : motivosAfastamentos.data}
                  enableShimmer={motivosAfastamentos.loadingData}
                  columns={columns}
                  selectionMode={SelectionMode.single}
                  selection={this._selection}
                  getKey={this._getKey}
                  selectionPreservedOnEmptyClick={true}
                  setKey="single"
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  onItemInvoked={this._onItemInvoked}
                />
              </ListContainer>
            )}
          </ContainerContent>
        </Wrapper>

        <CustomDialog
          hidden={!isDialogExcludeOpen}
          onDismiss={() => this.setState({ isDialogExcludeOpen: false })}
          dialogContentProps={dialogContentProps}
        >
          <DefaultButton
            onClick={() => this.setState({ isDialogExcludeOpen: false })}
            text="Cancelar"
          />
          <DeleteButton onClick={() => this.exclude()} text="Excluir" />
        </CustomDialog>
      </>
    );
  }

  private _onColumnClick = (
    ev: React.MouseEvent<HTMLElement>,
    column: IColumn
  ): void => {
    const { columns } = this.state;
    const newColumns: IColumn[] = columns.slice();
    let items: MotivosAfastamentosLoadDTO[] = [];
    if (this.state.isFiltering) {
      items = this.state.items;
    } else {
      items = this.props.motivosAfastamentos.data;
    }
    const currColumn: IColumn = newColumns.filter(
      (currCol) => column.key === currCol.key
    )[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = this._sort(
      items,
      currColumn.fieldName!,
      currColumn.isSortedDescending
    );
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };

  private _getKey(item: any, index?: number): any {
    if (item !== undefined) return item.key;
  }

  private _sort<T>(
    items: T[],
    columnKey: string,
    isSortedDescending?: boolean
  ): T[] {
    const result = (prop: string, obj: T) =>
      prop.split(".").reduce((a: any, b: any) => a[b] ?? "", obj);
    return items.sort((a: T, b: T) =>
      (
        isSortedDescending
          ? result(columnKey, a) < result(columnKey, b)
          : result(columnKey, a) > result(columnKey, b)
      )
        ? 1
        : -1
    );
  }
}

/**
 * Validação do formulário
 */
const validationMotivoSchema = yup.object().shape({
  descMotivoAfastamento: yup
    .string()
    .max(70, "Máximo de 100 caracteres")
    .required("Campo obrigatório"),
  flagMerito: yup.bool(),
});

const dialogContentProps: IDialogContentProps = {
  title: "Excluir?",
  closeButtonAriaLabel: "Close",
  subText: "Tem certeza de que deseja excluir este item?",
};

const itemsBreadCrumb: BreadcrumbItems[] = [
  {
    text: "Home",
    isCurrentItem: false,
    icon: "HomeSolid",
    onlyIcon: true,
    url: "/",
  },
  { text: "Motivos de Afastamentos", isCurrentItem: true },
];

const initialMotivo: MotivoAfastamentoAddOrEditDTO = {
  descMotivoAfastamento: "",
  flagMerito: false,
};

const btnStyle: Partial<ICommandBarStyles> = {
  root: {
    height: 44,
  },
};

const mapStateToProps = (state: RootState) => ({
  motivosAfastamentos: state.motivoAfastamentoReducer,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      ...getMotivosAfastamentos,
      ...getMotivoAfastamentoById,
      ...addMotivoAfastamento,
      ...editMotivoAfastamento,
      ...delMotivoAfastamento,
      ...setCurrentPage,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MotivosAfastamentos);
